<template>
  <div
    :class="[
      'container-' + organism.containerWidth,
      organism.removeMargin,
      'flex flex-wrap justify-center organism flexible-content-columns gap-x-8 gap-y-14',
    ]"
    :style="'background-color:' + organism.backgroundColor"
  >
    <div
      v-for="(item, index) in organism.item"
      :key="'item-' + index"
      :id="item.id"
      :class="[item.cssClasses, 'w-80 max-w-full']"
    >
      <NuxtLink v-if="item.imageLink" :to="item.imageLink" class="image-link block">
        <img
          v-if="item.fieldGroupName === 'item' && item.image?.sourceUrl"
          :src="item.image.sourceUrl"
          :alt="item.image.altText || item.image.title || ''"
          :class="organism.rounded"
          class="w-full h-auto object-cover"
          loading="lazy"
          decoding="async"
        />
      </NuxtLink>
      <div v-else>
        <img
          v-if="item.fieldGroupName === 'item' && item.image?.sourceUrl"
          :src="item.image.sourceUrl"
          :alt="item.image.altText || item.image.title || ''"
          :class="organism.rounded"
          class="w-full h-auto object-cover"
          loading="lazy"
          decoding="async"
        />
      </div>
      <img
        v-if="item.fieldGroupName === 'neighborhood_features'"
        :src="neighborhoodFeaturesIcon(item.category)"
        :alt="item.category"
        class=""
      />
      <h3
        v-if="item.title1"
        class="text-4xl font-bold text-center title font-archer"
      >
        {{ item.title1 }}
      </h3>
      <div
        v-if="item.fieldGroupName === 'neighborhood_features'"
        class="feature-title"
        v-html="item.title"
      ></div>
      <div
        v-if="item.description"
        class="description"
        v-html="item.description"
      ></div>
      <MoleculesButtons
        :buttons="item"
        :button-colors="[
          item.button1Color ?? 'button-blue',
          item.button2Color ?? 'button-white',
          item.button3Color ?? 'button-white',
        ]"
      />
    </div>

    <MoleculesButtons
      v-if="organism.button1"
      :buttons="organism"
      class="w-full"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  organism: Object,
});

onMounted(() => {
  if (props.organism.containerWidth === "full-width") {
    addFullWidthSupport();
  }
});

const roundedness = computed(() => {
  return result.value?.organisms?.hlOrganisms?.hlOrganism ?? [];
});
</script>
